<template>
  <!-- 生产管理系统 -->
  <div class="productionManagement maxWidth">
    <div
      class="productionManagement-bannner"
      :style="'background-image:url(' + bannerImg + ')'"
    >
      <div class="productionManagement-bannnerBox">
        <span class="edescription">{{ bannerList.alias }}</span>
        <span class="name">{{ bannerList.name }}</span>
        <span class="description">{{ bannerList.description }}</span>
        <button type="button" @click="clickParent">立即咨询</button>
      </div>
    </div>
    <NavAssembly :navList="navList" />
    <!-- 企业管理痛点 -->
    <div class="businessManagement" id="businessAdministration">
      <div class="businessManagement-top">
        <img src="../../assets/bigTy1.png" alt="" />
        <span>{{ typeList.name }}</span>
        <p>{{ typeList.description }}</p>
      </div>
      <div class="businessManagement-main">
        <div
          class="businessManagement-mainBox"
          v-for="(item, index) in typeList.lists"
          :key="index"
        >
          <div class="businessManagement-number">
            <img :src="item.num_img" alt="" />
          </div>
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
    <!-- /* 分界 */ -->
    <div class="coreProducts" id="coreProduct">
      <div class="coreProducts-top">
        <img src="../../assets/bigTy.png" alt="" />
        <span>{{ coreProductsList.name }}</span>
      </div>
      <div class="coreProducts-mian">
        <div class="coreProducts-mianLeft">
          <div
            class="coreProducts-mianLeftBox"
            v-for="(item, index) in coreProductsList.lists"
            :key="index"
            :class="{ titleActive: titleShow == index }"
            @click="titleCilck(index)"
          >
            <span>{{ item.name }}</span>
            <img src="../../assets/jiantou1.png" alt="" />
          </div>
        </div>
        <div class="coreProducts-mianRight">
          <div
            class=""
            v-for="(item, index) in coreProductsList.lists"
            :key="index"
          >
            <div class="coreProducts-mianRightBox" v-if="titleShow == index">
              <div class="coreProducts-mianRightBoxLeft">
                <div class="mianRightBoxLeft-top">
                  <span>{{ item.name }}</span>
                  <p>
                    {{ item.description }}
                  </p>
                </div>
                <div class="mianRightBoxLeft-bottom">
                  <span>核心功能:</span>
                  <div class="mianRightBoxLeft-bottomBox">
                    <div
                      class="mianRightBoxLeft-bottomBoxItem"
                      v-for="(itemText, indexText) in item.list"
                      :key="indexText"
                    >
                      <div class="bottomBoxItem-dain"></div>
                      <span>{{ itemText }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="coreProducts-mianRightBoxRight">
                <img :src="item.img" alt="" />
                <button type="button" @click="clickParent">立即咨询</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /* 分界 */ -->
    <div class="businessScenario" id="businessScenario">
      <div class="businessScenario-top">
        <img src="../../assets/bigTy.png" alt="" />
        <span>{{ iconList.name }}</span>
        <p>
          {{ iconList.description }}
        </p>
      </div>
      <div class="businessScenario-main">
        <div
          class="businessScenario-mainBox"
          v-for="(item, index) in iconList.lists"
          :key="index"
        >
          <div class="imgBox"><img :src="item.icon" alt="" /></div>
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>

    <ChooseUs :chooseUsList="chooseUsList" />
    <CommonProblem :commonProblemList="commonProblemList" />
    <DeliveryList :deliveryList="deliveryList" />
    <DevelopmentProcess :developmentProcessList="developmentProcessList" />
    <ZXDialog ref="mychild" />
  </div>
</template>

<script>
import NavAssembly from "../../components/NavAssembly.vue";
import ChooseUs from "../../components/ChooseUs.vue";
import CommonProblem from "../../components/CommonProblem.vue";
import DeliveryList from "../../components/DeliveryList.vue";
import DevelopmentProcess from "../../components/DevelopmentProcess.vue";
import ZXDialog from "../../components/ZXDialog.vue";
export default {
  name: "productionManagement",
  components: {
    NavAssembly,
    ChooseUs,
    CommonProblem,
    DeliveryList,
    DevelopmentProcess,
    ZXDialog
  },
  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      titleShow: 0,
      commonProblemList: {},
      chooseUsList: {},
      deliveryList: {},
      developmentProcessList: {},
      typeList: {},
      bannerList: {},
      bannerImg: "",
      coreProductsList: {},
      navList: [],
      iconList: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.get("index/common/getProductionManagement").then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.bannerImg = res.data.data["01"].banner[0].pic;
          this.navList = res.data.data["02"];
          this.typeList = res.data.data["03"];
          this.coreProductsList = res.data.data["04"];
          this.iconList = res.data.data["05"];
          this.chooseUsList = res.data.data["06"];
          this.commonProblemList = res.data.data["07"];
          this.deliveryList = res.data.data["08"];
          this.developmentProcessList = res.data.data["09"];
        }
      });
    },
    titleCilck(index) {
      this.titleShow = index;
    },
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.productionManagement {
  width: 1920px;
  margin: 0 auto;
  margin-top: 70px;
}
.productionManagement-bannner {
  height: 737px;
  /* background-image: url("~../../assets/sc-banner.jpg"); */
  background-repeat: no-repeat;
  /* background-size: 100%; */
  position: relative;
}

.productionManagement-bannnerBox {
  position: absolute;
  top: 149px;
  left: 311px;
  display: flex;
  flex-direction: column;
}
.productionManagement-bannnerBox .edescription {
  font-size: 66px;
  font-family: DIN BlackAlternate;
  font-weight: 600;
  color: rgba(69, 70, 71, 0.3);
  line-height: 76px;
  display: block;
  margin-bottom: 74px;
}
.productionManagement-bannnerBox .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 21px;
}
.productionManagement-bannnerBox .description {
  width: 518px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  display: block;
  margin-bottom: 100px;
}
.productionManagement-bannnerBox button {
  cursor: pointer;
  width: 210px;
  height: 54px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 6px 0px 6px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
/* <!-- 企业管理痛点 --> */
.businessManagement-top {
  height: 300px;
  background-image: url("~../../assets/YJ-banner.png");
  background-repeat: no-repeat;
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  position: relative;
  text-align: center;
  padding-top: 94px;
  margin-bottom: 110px;
}
.businessManagement-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 810px;
  top: 87px;
}
.businessManagement-top span {
  display: block;
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 24px;
}
.businessManagement-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.businessManagement-main {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.businessManagement-mainBox {
  width: 350px;
  height: 190px;
  padding-top: 31px;
  margin-right: 76px;
  margin-bottom: 180px;
  position: relative;
}
.businessManagement-mainBox img {
  display: block;
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
}
.businessManagement-mainBox span {
  display: block;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  margin-bottom: 28px;
}
.businessManagement-mainBox p {
  width: 340px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
.businessManagement-number {
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
.businessManagement-number img {
  display: block;
  width: 153px;
  height: 190px;
}
/* 分界 */
.coreProducts {
  height: 622px;
  background-image: url("~../../assets/coreProducts-banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  padding-top: 46px;
}
.coreProducts-top {
  text-align: center;
  position: relative;
  margin-bottom: 56px;
}
.coreProducts-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.coreProducts-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 776px;
  top: -14px;
}
.coreProducts-mian {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  position: relative;
}
.coreProducts-mianLeft {
  width: 280px;
  height: 460px;
  padding: 20px 0 54px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.7),
    rgba(255, 255, 255, 0.1)
  );
  z-index: 9;
}
.coreProducts-mianLeftBox {
  width: 280px;
  height: 84px;
  display: flex;
  justify-content: space-between;
  padding: 0 23px 0 49px;
  cursor: pointer;
  align-items: center;
}

.coreProducts-mianLeftBox img {
  display: block;
  width: 16px;
  height: 20px;
  display: none;
}
.coreProducts-mianLeftBox span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454647;
}
.titleActive {
  z-index: 9;
  background: linear-gradient(90deg, #dc3939, #ff4242);
  box-shadow: 0px 8px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 0px 6px 0px 0px;
  align-items: center;
}
.titleActive span {
  color: #ffffff;
}
.titleActive img {
  display: block;
}
.coreProducts-mianRight {
  /* width: 1060px; */
  height: 460px;
  position: relative;
  left: -60px;
  background: #ffffff;
  padding-top: 57px;
  padding-left: 110px;
}
.coreProducts-mianRightBox {
  display: flex;
}
.mianRightBoxLeft-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 76px;
}
.mianRightBoxLeft-top span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 24px;
}
.mianRightBoxLeft-top p {
  width: 393px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.mianRightBoxLeft-bottom > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 33px;
}
.mianRightBoxLeft-bottomBoxItem {
  display: flex;
  align-items: center;
  padding-left: 11px;
  margin-bottom: 21px;
}
.mianRightBoxLeft-bottomBoxItem .bottomBoxItem-dain {
  width: 6px;
  height: 6px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 0px 3px 0px 3px;
  margin-right: 11px;
}
.mianRightBoxLeft-bottomBoxItem > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  white-space: nowrap;
}
.coreProducts-mianRightBoxRight {
  display: flex;
  flex-direction: column;
  padding-right: 58px;
  margin-left: 52px;
}
.coreProducts-mianRightBoxRight img {
  display: block;
  width: 446px;
  height: 281px;
  margin-bottom: 44px;
}
.coreProducts-mianRightBoxRight button {
  margin: 0 auto;
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 6px 0px 6px 0px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
/* 分界 */
.businessScenario {
  padding-top: 104px;
}
.businessScenario-top {
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 79px;
}
.businessScenario-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 14px;
}
.businessScenario-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 760px;
  top: -14px;
}
.businessScenario-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.businessScenario-main {
  width: 1114px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.businessScenario-mainBox {
  width: 112px;
  text-align: center;
  margin-bottom: 59px;
  margin-right: 88px;
}
.businessScenario-mainBox:nth-child(6n) {
  margin-right: 0px;
}
.businessScenario-mainBox .imgBox {
  margin: 0 auto;
  width: 60px;
  height: 60px;
  background: #ffffff;
  /* border: 6px solid rgba(255, 66, 66, 0.1); */
  border: 1px solid rgba(255, 66, 66, 0.3);
  box-shadow: 0px 0px 10px rgba(255, 66, 66, 0.3);
  border-radius: 25px;
  padding-top: 15px;
  margin-bottom: 29px;
}
.businessScenario-mainBox .imgBox img {
  display: block;
  margin: 0 auto;
  height: 30px;
}
.businessScenario-mainBox span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
</style>



// WEBPACK FOOTER //
// src/views/productIntroduction/ProductionManagement.vue